import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './arrow.svg'


_pushScopeId("data-v-f85475fa")
const _hoisted_1 = { class: "desktop-links" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Bond ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Airdrop ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" vexPolar ")
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = { class: "dropdown-title flex w-full gap-[12px]" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Bridges ")
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-content w-full" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://synapseprotocol.com/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex w-full justify-between" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Synapse"),
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://multichain.xyz/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex w-full justify-between" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Multichain"),
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://allbridge.io/classic/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex w-full justify-between" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Allbridge"),
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://cbridge.celer.network/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex w-full justify-between" }, [
      /*#__PURE__*/_createElementVNode("div", null, "CBridge"),
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://rainbowbridge.app/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex w-full justify-between" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Rainbow Bridge"),
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://meson.fi/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex w-full justify-between" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Meson"),
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
    ])
  ])
], -1)
_popScopeId()

import { useRoute } from 'vue-router';

import useWeb3 from '@/services/web3/useWeb3';

import DesktopLinkItem from './DesktopLinkItem.vue';
import ArrowDown from './arrowdown.svg';
import Arrow from './arrow.svg';

/**
 * COMPOSABLES
 */

export default _defineComponent({
  setup(__props) {

const { isGoerli } = useWeb3();

const route = useRoute();

/**
 * METHODS
 */
function isActive(page: string): boolean {
  if (route.name === page) return true;
  return false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DesktopLinkItem, {
      to: "/trade",
      active: isActive('trade')
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Swap')), 1)
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(DesktopLinkItem, {
      to: "/",
      active: isActive('home')
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Earn')), 1)
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(DesktopLinkItem, {
      to: "/sunrise",
      active: isActive('sunrise')
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Sunrise')), 1)
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(DesktopLinkItem, {
      to: "/bond",
      active: isActive('bond')
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(DesktopLinkItem, {
      to: "/airdrop",
      active: isActive('airdrop')
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(DesktopLinkItem, {
      to: "/vexpolar",
      active: isActive('vexpolar')
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["active"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("img", { src: _unref(ArrowDown) }, null, 8, _hoisted_8)
      ]),
      _hoisted_9
    ])
  ]))
}
}

})